"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgArrowLight(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "0 0 11 8", fill: "none" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.629.667L10.827 4 7.629 7.333 6.74 6.69l2.1-2.188H.827V3.498H8.84l-2.1-2.189.888-.642z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('ArrowLight')(SvgArrowLight);
//# sourceMappingURL=ArrowLight.js.map